export default __webpack_public_path__ + "static/media/3.411f1735.jpg";